import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

// Sub-item CRUD lives in the itineraries domain; both the operations list and
// the planner read the item, so refresh both (re-nests the page) on settle.
const useInvalidateItems = () => {
  const utils = trpc.useUtils();
  return () => invalidateItemQueries(utils);
};

export const useCreateSubitem = () => {
  const invalidate = useInvalidateItems();
  return trpc.itineraryItems.createSubitem.useMutation({
    onSettled: invalidate,
  });
};

export const useDeleteSubitem = () => {
  const invalidate = useInvalidateItems();
  return trpc.itineraryItems.deleteSubitem.useMutation({
    onSettled: invalidate,
  });
};

// Re-parent a top-level item under another ("Add as subitem" / transform).
export const useSetItemParent = () => {
  const invalidate = useInvalidateItems();
  return trpc.itineraryItems.setParent.useMutation({
    onSettled: invalidate,
  });
};
